import { Observable } from "rxjs";
import { tap, mergeMap, flatMap, filter, concatMap } from "rxjs/operators";
import { formOperation } from "../../wrappers/formOperation";
import { TAdminUserEditable } from "../../../../domain/codecs/formEditable/AdminUserEditable";
import { doFormValuesMatch } from "../../../../shared/src/codecs/types/formEditable";
import { TActionsDefinitionsList } from "./TAction";
import { action, routeAction } from "./actionFunctions";
import { AdminResetUserAuthenticatorForm } from "../../../../domain/codecs/form/AuthenticatorForm";

export const actions: TActionsDefinitionsList = [
    routeAction("VIEW_ADMIN", (obs$, lens, set, get) => {
        obs$.pipe(
            mergeMap(() => formOperation("GetAdminPage", lens.homes_admin_page.data.get()(get()))),
            tap((response) => set(lens.homes_admin_page.data.set(response))),
        ).subscribe();

        obs$.pipe(
            mergeMap(() => formOperation("GetCaseAutoAssignmentRules", lens.case_assignment_page_form.get()(get()))),
            tap((response) => set(lens.case_assignment_page_form.set(response))),
        ).subscribe();

        obs$.pipe(
            mergeMap(() => formOperation("GetLenders", lens.lenders_page_form.get()(get()))),
            tap((response) => set(lens.lenders_page_form.set(response))),
        ).subscribe();

        obs$.pipe(
            mergeMap(() => formOperation("GetEmailTemplates", lens.email_templates_form.get()(get()))),
            tap((response) => set(lens.email_templates_form.set(response))),
        ).subscribe();

        obs$.pipe(
            mergeMap(() => formOperation("GetRoadblockAssignmentRules", lens.roadblock_assignment_page_form.get()(get()))),
            tap((response) => set(lens.roadblock_assignment_page_form.set(response))),
        ).subscribe();
    }),
    action("HOMES_ADMIN_USERS_CHANGE", (obs$: Observable<Array<TAdminUserEditable>>, lens, setState) => {
        obs$.pipe(
            tap((adminUsers) => setState(lens.homes_admin_page.data.output.adminUsers.set(adminUsers))),
            concatMap((adminUsers) => adminUsers),
            filter((member) => member.status === "requiresSubmission"),
            tap((member) => setState(lens.homes_admin_page.data.output.adminUsers.where(doFormValuesMatch(member, "id")).status.set("submitting"))),
            flatMap((adminUser) => formOperation("UpdateAdminUser", adminUser)),
            tap((member) => setState(lens.homes_admin_page.data.output.adminUsers.where(doFormValuesMatch(member, "id")).status.set(member.status))),
        ).subscribe();
    }),
    action("CRM_ADMIN_RESET_USER_AUTHENTICATOR", (obs$: Observable<string>, lens, setState, getState) => {
        obs$.pipe(
            concatMap((user_id) => formOperation("AdminResetUserAuthenticator", {
                ...AdminResetUserAuthenticatorForm.newDefault(),
                edited: { user_id },
            })),
            // Re-read the page rather than striking the id out locally: the badge should
            // reflect what the database says, not what we hoped the reset did.
            concatMap(() => formOperation("GetAdminPage", lens.homes_admin_page.data.get()(getState()))),
            tap((response) => setState(lens.homes_admin_page.data.set(response))),
        ).subscribe();
    }),
];
